/**
 * Regola dei mid-roll a tempo del VOD, in funzioni pure (niente player, niente DOM) cosi' si
 * possono testare senza browser. Documento: doc/Fix/2026-10-13-mid-roll-vod-dopo-seek-progetto.md
 *
 * - senza salti parte il punto che il video attraversa;
 * - dopo un salto parte l'ULTIMO punto superato, solo se la sua ad non e' mai partita;
 * - i punti saltati piu' indietro restano disponibili: tornandoci sopra partono.
 * In tutte le funzioni times e' ordinato e senza doppioni (normalizeMidRollTimes) e used[i] dice
 * se l'ad del punto i e' gia' partita nel caricamento della pagina.
 */
/**
 * Tempi dei mid-roll in secondi, ordinati e senza doppioni.
 * Dall'admin arrivano come stringa ("300,600"), ma li accetto anche come array o numero.
 * Prima un array disattivava il mid-roll e una stringa vuota faceva partire l'ad al primo secondo.
 */
export function normalizeMidRollTimes(rawTimes) {
    let values = [];
    if (Array.isArray(rawTimes)) {
        values = rawTimes;
    }
    else if (typeof rawTimes === "string") {
        values = rawTimes.split(",");
    }
    else if (typeof rawTimes === "number") {
        values = [rawTimes];
    }
    const times = values
        .map((value) => Number(String(value).trim()))
        .filter((value) => Number.isFinite(value) && value > 0);
    // Due tempi uguali sono lo stesso punto (19.4.4): altrimenti partirebbero due break di fila
    return [...new Set(times)].sort((a, b) => a - b);
}
/**
 * Dopo un salto: indice dell'ultimo punto <= time, oppure -1 se non c'e' o se e' gia' usato.
 * Se l'ultimo punto e' usato NON ripiego su uno libero piu' indietro: vale solo l'ultimo superato.
 */
export function findMidRollAfterSeek(times, used, time) {
    let index = -1;
    while (index + 1 < times.length && times[index + 1] <= time) {
        index++;
    }
    return index !== -1 && !used[index] ? index : -1;
}
/**
 * Senza salti: indice dell'ultimo punto attraversato tra due timeupdate, cioe' dentro
 * (fromTime, toTime], oppure -1 se non c'e' o se e' gia' usato.
 * Uso l'intervallo e non "ultimo punto <= toTime": un punto rimasto libero (waterfall vuoto)
 * altrimenti ripartirebbe a ogni timeupdate, 4 volte al secondo.
 */
export function findMidRollCrossed(times, used, fromTime, toTime) {
    const index = findMidRollAfterSeek(times, used, toTime);
    return index !== -1 && times[index] > fromTime ? index : -1;
}
/**
 * Indice del primo punto libero che arriva entro prefetchSeconds (time < punto <= time +
 * prefetchSeconds), oppure -1. Serve a far girare il waterfall in background prima del punto.
 */
export function findMidRollToPrefetch(times, used, time, prefetchSeconds) {
    return times.findIndex((pointTime, index) => !used[index] && pointTime > time && pointTime <= time + prefetchSeconds);
}
/**
 * Posizioni in percentuale (0-100) delle barrette dei punti non ancora consumati.
 * Un punto uguale o oltre la durata non si disegna: finirebbe fuori dalla barra e non puo' partire.
 */
export function midRollMarkerPositions(times, used, duration) {
    if (!Number.isFinite(duration) || duration <= 0) {
        return [];
    }
    return times
        .filter((pointTime, index) => !used[index] && pointTime < duration)
        .map((pointTime) => (pointTime / duration) * 100);
}
